// Form validation for Employee form
import {
  dropdownValidator,
  emailValidator,
  multiselectValidator,
  nameValidator,
  phoneValidator,
  userValidator
} from '../fields';

const config = {};

export default {
  firstName: nameValidator({ mandatory: true }),
  lastName: nameValidator({ mandatory: true }),
  email: emailValidator({ mandatory: true }),
  site: dropdownValidator({ mandatory: true }),
  requesterRole: dropdownValidator({ mandatory: true }),
  // phoneNumber: phoneValidator({ mandatory: true }),
  reportingManager: userValidator(config),
  'designation.designationId': dropdownValidator(config),
  'businessFunction.businessFunctionId': dropdownValidator(config),
  'team.teamId': dropdownValidator(config)
};
